import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import "./App.css";
import "./Assets/css/custom.css";
import Routes from "./Routes";
import Header from "./Components/Common/Header";
const App = () => {
  const location = useLocation();
  const auth = useSelector((state) => state.auth);

  return (
    <React.Fragment>
      <div className="d-flex flex-column min-vh-100">
        <div className="header-main">
          {location.pathname === "/Login" ||
          location.pathname === "/" ||
          location.pathname.indexOf("/RXLImages") > -1 ? (
            <></>
          ) : (
            <Header></Header>
          )}
          <Routes url={location.pathname} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default App;
